define('controller/settings/disclosureResolutionSetting',['require','exports','module','fukit','view/settings/disclosureResolutionSetting.page.view','model/settings.model','underscore','backbone.radio','fukit'],function(require, exports, module) {
  // prettier-ignore
  var BaseController                      = require('fukit').BaseController,
      DisclosureResolutionSettingPageView = require('view/settings/disclosureResolutionSetting.page.view'),
      SettingsModel                       = require('model/settings.model'),
      _                                   = require('underscore'),
      Radio                               = require('backbone.radio'),
      ROLES                               = require('fukit').Roles;


  var  coiModel;
  var  productNewCoiUiValue = false;
  const enabledProductCollection =   Radio.request(
      'AppKit.resourceService',
      'resource',
      'enabledProductCollection'
  );

  if (!_.isUndefined(enabledProductCollection)) {
    coiModel = enabledProductCollection.findWhere({name: 'COI', active: true});
    const dataModel = coiModel.collection.models;
    const filteredDataArray = dataModel.filter(function (item) {
      return item.attributes.name === "COI" && item.attributes.active === true;
    });
    productNewCoiUiValue = filteredDataArray[0].attributes.productNewCoiUi;
  }

  if(productNewCoiUiValue){
    localStorage.setItem("productNewCoiUiValue", productNewCoiUiValue.toString());
    location.assign(location.origin + '/coi-react/disclosure/resolution');
  }

  var DisclosureResolutionSettingController = BaseController.extend({
    radioRequests: {
      'controllers DisclosureResolutionSettingController': '@constructor',
    },

    pageView: DisclosureResolutionSettingPageView,

    stateConfiguration: {
      defaults: {
        roles: ROLES.GLOBALACCESSROLES,
      },
    },

    resources: {
      settingsModel: {
        model: SettingsModel,
        fetchOnStart: true,
        fetchWhenNew: true
      }
    },
  });

  module.exports = DisclosureResolutionSettingController;
});

